<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-4" lang="en-GB"><a id="_idTextAnchor005"></a>Keep your strength</h1>
<p class="Verse-first" lang="en-GB">Keep your strength my little girl </p>
<p class="Verse-main" lang="en-GB">Keep your strength</p>
<p class="Verse-main" lang="en-GB">Lose it not, keep your strength</p>
<p class="Verse-main" lang="en-GB">Listening to my advice, to my voice</p>
<p class="Verse-main" lang="en-GB">Do not give it away, keep your strength</p>
<p class="Verse-main" lang="en-GB">As a young sweet and tender flower</p>
<p class="Verse-main" lang="en-GB">You know not the meaning of such treasure</p>
<p class="Verse-main" lang="en-GB">You will know its priceless value</p>
<p class="Verse-main" lang="en-GB">Listening to no hungry fool</p>
<p class="Verse-main" lang="en-GB">Keep your blood, keep your strength</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB6.vue?d753ce30